import AppConfig from 'appConfig';
import AbstractFetch from './AbstractFetch';

class AlertFetch extends AbstractFetch {
  static getAll(criterias = {}) {
    return AbstractFetch.fetch(
      AppConfig.apiUrl + '/events/alerts/search',
      {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(criterias),
      },
      true
    )
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.log('Error fetch alerts:', e);
        return JSON.stringify([]);
      });
  }

  /**
   *
   * @param {object} criteria
   * @returns
   */
  static delete(criteria) {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/events/alerts/bulk', {
      method: 'DELETE',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(criteria),
    }).catch((e) => {
      console.log('Error delete alerts with alert_ids:' + JSON.stringify(criteria.ids), e);
      return JSON.stringify([]);
    });
  }
}

export default AlertFetch;
